/**
 * Transition douce des photos au changement de variante.
 * Horizon remplace tout le <media-gallery> d'un coup (coupe sèche).
 * Ici : on réserve la hauteur (pas de saut), on masque la nouvelle
 * galerie puis on la fait apparaître en fondu UNE FOIS l'image chargée
 * (évite le « blanc puis pop »). Aucune modif du JS cœur Horizon.
 */
(function () {
  'use strict';

  var reduce = false;
  try {
    reduce = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  var lastHeight = 0;

  function currentGallery() {
    return document.querySelector('media-gallery');
  }

  function mediaIds(gallery) {
    return Array.prototype.map
      .call(gallery.querySelectorAll('[data-media-id]'), function (n) {
        return n.getAttribute('data-media-id');
      })
      .join(',');
  }

  /* Avant remplacement : mémoriser la hauteur pour éviter le saut. */
  document.addEventListener('variant:update', function (event) {
    /* Si les photos ne changent pas (ex. moutures) → pas de fondu (sinon flash inutile). */
    try {
      var src = event && event.detail && event.detail.data && event.detail.data.html;
      var cur = currentGallery();
      var next = src && src.querySelector ? src.querySelector('media-gallery') : null;
      if (cur && next && mediaIds(cur) && mediaIds(cur) === mediaIds(next)) return;
    } catch (e) {}

    var g = currentGallery();
    if (g) lastHeight = g.getBoundingClientRect().height;

    if (reduce) return;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var gallery = currentGallery();
        if (!gallery) return;

        /* Réserve la hauteur le temps du swap. */
        if (lastHeight > 0) gallery.style.minHeight = lastHeight + 'px';

        /* Masque puis prépare le fondu. */
        gallery.style.opacity = '0';
        gallery.style.transition = 'opacity 0.32s ease';

        var reveal = function () {
          gallery.style.opacity = '1';
          setTimeout(function () {
            gallery.style.minHeight = '';
            gallery.style.transition = '';
          }, 360);
        };

        /* Attend que l'image active soit chargée (sinon fondu sur du vide). */
        var img = gallery.querySelector(
          '.is-active img, .product-media-container img, img'
        );
        if (img && !img.complete) {
          var done = false;
          var go = function () { if (!done) { done = true; reveal(); } };
          img.addEventListener('load', go, { once: true });
          img.addEventListener('error', go, { once: true });
          setTimeout(go, 700); /* filet de sécurité */
        } else {
          requestAnimationFrame(reveal);
        }
      });
    });
  });
})();
